import RCLayout from "../../components/RCLayout";

const Resources = () => {
    return (
        <RCLayout/>
    );
}

export default Resources;